"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJCycleGraphic = void 0;
class CGJCycleGraphic extends Phaser.GameObjects.Container {
    constructor(scene, x, y, r, cycle, drawArrow = true, rotationOffset = 0) {
        super(scene, x, y);
        this.radius = r;
        this.cycle = cycle;
        this.subCycles = [];
        this.rotationOffset = rotationOffset;
        this.cycle.graphic = this;
        let startingAngle = 0;
        this.graphics = this.scene.add.graphics();
        this.add(this.graphics);
        for (let i = 0; i < this.cycle.elements.length; i++) {
            const element = this.cycle.elements[i];
            this.graphics.fillStyle(element.color);
            const addAngle = -1 * (element.time / this.cycle.totalTime * Math.PI * 2);
            this.graphics.slice(0, 0, this.radius, startingAngle, startingAngle + addAngle, true);
            startingAngle += addAngle;
            this.graphics.fill();
            const newR = r / (element.subCycles.length + 2);
            const anglePer = addAngle / (element.subCycles.length);
            const inset = .9;
            for (let i = 0; i < element.subCycles.length; i++) {
                const angle = anglePer * -(i + .5) + startingAngle;
                const cycle = new CGJCycleGraphic(this.scene, Math.cos(angle) * (r - newR) * inset, Math.sin(angle) * (r - newR) * inset, newR, element.subCycles[i], drawArrow, angle - Math.PI / 2);
                cycle.update(0);
                this.scene.add.existing(cycle);
                this.add(cycle);
                this.subCycles.push(cycle);
                if (drawArrow) {
                    const pointer = this.scene.add.sprite(Math.cos(angle) * r * inset, Math.sin(angle) * r * inset, 'Pointer').setOrigin(0.5, 0);
                    this.add(pointer);
                    pointer.setDisplaySize(24, 24);
                    pointer.rotation = angle - Math.PI / 2;
                }
            }
        }
        this.graphics.lineStyle(2, 0x0);
        this.graphics.strokeCircle(0, 0, this.radius);
    }
    update(percent) {
        this.rotation = Math.PI * 2 * percent + Math.PI / 2 + this.rotationOffset;
    }
}
exports.CGJCycleGraphic = CGJCycleGraphic;
